import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IFiscalYear extends IModel {
	endDate?: Date;
	startDate?: Date;
	year?: number;
}

const fiscalYearFactory = modelFactory.createFactory<IFiscalYear>('FiscalYear', _.assign({}, model, {
	endDate: {
		setFilters: valueFilters.toUtcDate
	},
	startDate: {
		setFilters: valueFilters.toUtcDate
	},
	year: {
	}
}));

export default fiscalYearFactory;